import './index.less';

import { Button } from '@bfe/moly';
import { UserIcon } from '@bfe/moly-icons';

import AccountBasicItem from '@/components/AccountBasicItem';
import { SecuritySettingModalNames } from '@/components/SecuritySettingModalManager';
import { useUserInfo } from '@/hooks/useUserInfo';
import { useI18nContext } from '@/i18n/I18n';
import { useSecuritySettingModal } from '@/store/useSecuritySettingModal/useSecuritySettingModal';
import { useSecuritySettingModalData } from '@/store/useSecuritySettingModal/useSecuritySettingModalData';
import { sensors } from '@/utils/skynet';

import { AvatarNFTLink } from './AvatarNFTLink';

const AvatarSetting = () => {
  const { user } = useUserInfo();
  const { avatar } = useSecuritySettingModalData();
  const [$t] = useI18nContext();
  const { openSecuritySettingModal } = useSecuritySettingModal();

  return (
    <>
      {user?.is_submember !== true && (
        <AccountBasicItem
          icon="account"
          molyIcon={<UserIcon />}
          text={$t('avatarSet')}
          subText={
            <AvatarNFTLink
              content={$t('avatarSetDesc')}
              linkContent={$t('avatarLinkToNFTMarkets')}
            />
          }
          status={avatar.avatar_id ? true : false}
          statusNode={avatar.avatar_id ? $t('Set up Tip') : $t('Not Setup Tip')}
          operation={
            <Button
              size="small"
              data-radius="small"
              variant="secondary"
              onClick={() => {
                sensors?.click?.({
                  button_name: 'change_avatar_setting',
                });
                openSecuritySettingModal(SecuritySettingModalNames.Avatar);
              }}
            >
              {$t('Set up')}
            </Button>
          }
        />
      )}
    </>
  );
};
export default AvatarSetting;
